//@flow
import React from 'react';
import classnames from 'classnames';

import CheckmarkCircleIcon from 'dibs-vg/dist/react/checkmark-circle';
import { Tooltip } from 'dibs-elements/exports/Tooltip';

import styles from './BenefitsChartCell.scss';

import type { Node } from 'react';

type Renderable = Node | boolean;

type Props = {
    children?: ?Renderable,
    className?: ?string,
    dataTn?: string,
    tooltipContent?: ?Renderable,
};

export function BenefitsChartCell(props: Props) {
    const { children, className, dataTn, tooltipContent } = props;

    const cellClass = classnames(styles.cell, className);
    const cellContent =
        children && typeof children === 'boolean' ? (
            <CheckmarkCircleIcon className={styles.checkmark} />
        ) : (
            children
        );

    return (
        <div className={cellClass} data-tn={dataTn}>
            {tooltipContent && (
                <div className={styles.tooltipContainer}>
                    <Tooltip direction="top" isVisible type="medium">
                        <div>{tooltipContent}</div>
                    </Tooltip>
                </div>
            )}
            {cellContent}
        </div>
    );
}
